import {
  DoGood,
  InternalHero,
  PetLandingPageType,
  Pricing,
  Questions,
  Reviews,
  TakeBetterCare,
  ValuePoints,
  WhatIsCovered,
} from '@/components/pet';
import { PageWrapper } from '@/components/shared/Content';
import Layout from '@/components/shared/Layout';
import { SEO } from '@/components/shared/SEO';
import { useGeoLookupContext } from '@/hooks/useGeoLookupContext';
import { config } from '@/pageConfig/pet/dogs/us/en';
import { PET_LANDING_PAGE } from '@/utils/productAdaPages';
import { PRODUCT_PET } from '@/utils/products';
import { useEffect } from 'react';

export default function DogsPage() {
  const { trackEventWithGeolocation } = useGeoLookupContext();

  // biome-ignore lint/correctness/useExhaustiveDependencies: want to track event only once
  useEffect(
    () =>
      trackEventWithGeolocation('pet_landing_page.viewed', {
        pet_lp_type: PetLandingPageType.Dog,
      }),
    [],
  );

  return (
    <Layout
      headerActions={config.layout.headerActions}
      product={PRODUCT_PET}
      page={PET_LANDING_PAGE}
      productType={PRODUCT_PET}
      menuCheckPricesExtraAnalyticsParams={{
        pet_lp_type: PetLandingPageType.Dog,
      }}
    >
      <SEO {...config.seo} />
      <PageWrapper>
        <InternalHero petLandingPageType={PetLandingPageType.Dog} />
        <ValuePoints petLandingPageType={PetLandingPageType.Dog} />
        <WhatIsCovered petLandingPageType={PetLandingPageType.Dog} />
        <TakeBetterCare petLandingPageType={PetLandingPageType.Dog} />
        <Pricing petLandingPageType={PetLandingPageType.Dog} />
        <Reviews petLandingPageType={PetLandingPageType.Dog} />
        <Questions petLandingPageType={PetLandingPageType.Dog} />
        <DoGood petLandingPageType={PetLandingPageType.Dog} />
      </PageWrapper>
    </Layout>
  );
}
